/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb15Inputs */

const en__field_enum_pbs_fb15 = /** @type {(inputs: _Field_Enum_Pbs_Fb15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 01 Faculty of Law`)
};

const de__field_enum_pbs_fb15 = /** @type {(inputs: _Field_Enum_Pbs_Fb15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 01 Rechtswissenschaft`)
};

/**
* | output |
* | --- |
* | "F 01 Faculty of Law" |
*
* @param {_Field_Enum_Pbs_Fb15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb15 = /** @type {((inputs?: _Field_Enum_Pbs_Fb15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb15(inputs)
	return de__field_enum_pbs_fb15(inputs)
});
export { _field_enum_pbs_fb15 as "_field_enum_PBS_FB1" }